import { render, staticRenderFns } from "./currentLoan.vue?vue&type=template&id=382620e1"
import script from "./currentLoan.vue?vue&type=script&lang=js"
export * from "./currentLoan.vue?vue&type=script&lang=js"
import style0 from "./currentLoan.vue?vue&type=style&index=0&id=382620e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports